import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/goodsorder/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/goodsorder/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/business/goodsorder/updateById', data)
}
